<template>
    <div class="force-login">
        <div class="o-main-content-area">
            <!-- <h1>force login</h1> -->
        </div>
    </div>
</template>
<script>
    import service from '../services';
    import { mapGetters, mapActions } from 'vuex';
    import {global } from '../global.js';

    export default {
        data() {
            return {}
        },
        created(){
            // console.log('route', this.$route.params.type, this.$route.params.id,  this.$route.params.token);
            let loginType=this.$route.params.type;
            if(loginType=='client'){
                // console.log('called client')
                this.$Progress.start();
                service.get('universal_login', {
                    'Authorization': atob(this.$route.params.token),
                    'userid': atob(this.$route.params.id),
                    'url': window.location.href.split('#')[0],
                }).then((res) => {
                    // console.log('login success', res);
                    if (res.data.status_code == "0") {
                        this.$Progress.fail();
                        this.$router.push({
                            path: "/login"
                        });
                    } else {
                        // console.log('correct');
                        let data = res.data.result;
                        this.$store.dispatch('userSession', data);
                        // console.log('correct*', data);
                        this.$cookies.set("csLogin", data.role.slug, "23h");
                        this.$cookies.set("date_format", data.user.employees[0].date_format, "23h");
                        this.$cookies.set("time_format", data.user.employees[0].time_format, "23h");
                        this.$Progress.finish();
                        if (data.role.slug != "super-admin") {
                            this.$store.dispatch('setLoginSuper', true);
                            this.$cookies.set("time_zone", data.user.employees[0].client_employee.clients.timezone, "23h");
                            var notifyType = (data.user.employees[0].email_notification == 1) ? 'email' : 'sms';
                            this.$store.dispatch('setNotificationType', notifyType);
                            this.$store.dispatch('setClientdata', data.user.employees[0].client_employee.clients);
                            // location.reload(true);
                            window.location.replace(window.location.href.split('#')[0]);
                            if (data.role.slug == "client-admin" || data.role.slug == "power-user" && data.user.employees[0].client_employee) {
                                this.$router.push({
                                    path: "/jobList"
                                });
                            } else {
                                this.$router.push({
                                    path: "/schedule/"+btoa(this.employeeId),
                                });
                            }

                        } else {
                            // location.reload(true);
                            this.$router.push({
                                path: "/clientList"
                            });
                        }

                    }
                }).catch((err) => {
                    console.log(err);
                    this.$router.push({
                        path: "/login"
                    });
                });
            }else if(loginType=='employer'){
                this.$Progress.start();
                service.get('employer_universal_login', {
                    'Authorization': atob(this.$route.params.token),
                    'employerid': atob(this.$route.params.id),
                    'url': "http://labour." + global[0].CLIENT_BASE,
                })
                .then((res) => {
                    // console.log(res);
                    if (res.data.status_code == 0) {
                        this.$Progress.fail();
                        this.$router.push({
                            path: "/login"
                        });
                    } else {
                        // console.log('correct');
                        let data = res.data.result;

                        this.$store.dispatch('userSession', data);
                        this.$cookies.set("csLogin", data.role.slug, "23h");
                        this.credential_err = "";
                        this.$Progress.finish();
                        window.location.replace(window.location.href.split('#')[0]);
                        $('.wrapper').css('margin-left', '60px');
                        if (data.role.slug == "employer-admin" || data.role.slug == "employer") {
                            this.$router.push({
                                path: "/employerUserList"
                            });
                        } else {
                            location.reload(true);
                            this.$router.push({
                                path: "/clientList"
                            });
                        }

                    }
                    //window.location.href = "http://" + subdomain + "." + global[0].CLIENT_BASE;
                }).catch((err) => {
                    console.log(err);
                    this.$router.push({
                        path: "/login"
                    });
                });
            }else if(loginType=='employee'){

                console.log('Employee');
                this.$Progress.start();
                service.get('employee_universal_login', {
                    'Authorization': atob(this.$route.params.token),
                    'employeeid': atob(this.$route.params.id),
                    'url': "http://login." + global[0].CLIENT_BASE,
                })
                .then((res) => {
                    if (res.data.status_code == "0") {
                        this.$Progress.fail();
                        this.$notify.error({
                            title: 'Error',
                            message: 'Sorry! Unable to login'
                        })
                        this.$router.push({
                            path: "/login"
                        });
                    } else {
                        let data = res.data.result;
                        console.log(data.role);
                        this.getIntoApp(res);
                    }
                }).catch((err) => {
                    console.log(err);
                    this.$router.push({
                        path: "/login"
                    });
                });
            }else{
                this.$router.push({
                    path: "/login"
                });
            }
        },

        methods: {
            async getIntoApp(res) {
                localStorage.removeItem('vuex');
                if (res.data.status_code == 0) {
                    this.$Progress.fail();
                    this.loading = false;
                    this.credential_err = res.data.status_message;
                } else {
                    let data = res.data.result;
                    this.$store.dispatch('setTokenExpiry', data.token_expiry);
                    this.$store.dispatch('userSession', data);
                    this.$store.dispatch('setLoginSuper', false);
                    this.$cookies.set("csLogin", data.role.slug, "23h");
                    this.$cookies.set("csLogin", data.role.slug, "23h",'/mobile');
                    this.credential_err = "";
                    this.$Progress.finish();
                    $('.wrapper').css('margin-left', '60px');
                    let self = this;
                    var a =JSON.parse(localStorage.getItem('vuex'));
                    // var userRole =a && a.user && a.user.userData && a.user.userData.role?a.user.userData.role.slug:null;
                    // if(userRole){
                    //     var tags =['csSupport'];
                    //     var restoreId =null;
                    //     var client = null;
                    //     var phone ='';
                    //     var user_id ='';
                    //     var first_name="";
                    //     var last_name="";
                    //     var email=""
                    //     if(a.user.userData.user && a.user.userData.user.freshchat){
                    //         restoreId = a.user.userData.user.freshchat.restore_id;
                    //     }
                    //     if(userRole!='employer-admin' && userRole!='employer' && userRole!='super-admin' && a.user.userData.user && a.user.userData.user.employees && a.user.userData.user.employees.length && a.user.userData.user.employees[0].client_employee && a.user.userData.user.employees[0].client_employee.clients){
                    //         client = a.user.userData.user.employees[0].client_employee.clients.subdomain;
                    //     }
                    //     if(a.user.userData.user){
                    //         user_id = a.user.userData.user.id;
                    //         first_name = a.user.userData.user.first_name;
                    //         last_name = a.user.userData.user.last_name;
                    //         email = a.user.userData.user.email;
                    //         if(a.user.userData.user.phones && a.user.userData.user.phones.length){
                    //             phone = a.user.userData.user.phones[0].phone_number;
                    //         }
                    //     }
                    //     if(userRole=='employee' || userRole=='power-user'){                                            
                    //         if(a.user.userData.user && a.user.userData.user.employees){
                    //             for(var key in a.user.userData.user.employees){
                    //                 if(a.user.userData.user.employees[key].client_employee && a.user.userData.user.employees[key].client_employee.clients && a.user.userData.user.employees[key].client_employee.clients["widget_tags"]){
                    //                     var temp_tags = JSON.parse(a.user.userData.user.employees[key].client_employee.clients["widget_tags"]);
                    //                     if(temp_tags && temp_tags.length){
                    //                         tags=tags.concat(temp_tags)
                    //                     }
                    //                 }
                    //             }
                    //         }
                    //     }
                    //     localStorage.setItem('tags', JSON.stringify(tags));
                        // await window.fcWidget.init({
                        //     token:"5f5b4092-cff9-4586-9c85-5d4c79365f71",
                        //     host: "https://wchat.freshchat.com",
                        //     externalId: a.user.userData.user.id,
                        //     restoreId: restoreId ? restoreId : null,
                        //     tags: tags,
                        //     config: {
                        //         headerProperty: {
                        //         backgroundImage: 'https://admin.callsteward.com/static/assets/images/login-bg.jpg',
                        //         hideChatButton: false,
                        //         }
                        //     }
                        // });
                        // await window.fcWidget.user.get(function(resp) {
                        //     console.log("Check 1", resp);
                        //     var status = resp && resp.status,
                        //     data = resp && resp.data;
                        //     console.log('Get User Success', resp);
                        //     if (status !== 200) {
                        //         console.log('Get User not 200', resp)
                        //         window.fcWidget.user.setProperties({
                        //             firstName: a.user.userData.user.first_name,              // user's first name
                        //             lastName: a.user.userData.user.last_name,                // user's last name
                        //             email: a.user.userData.user.email,    // user's email address
                        //             phone: String(phone),            // phone number without country code
                        //             client: String(client),   // user's meta property 3
                        //             role: String(userRole),
                        //             plan: "Estate",                 // user's meta property 1
                        //             status: "Active",               // user's meta property 2
                        //             "Restore Id": restoreId?restoreId:null
                        //         });
                        //         console.log("FcWidget created Start");
                        //         window.fcWidget.on('user:created', ((resuser) => {
                        //             console.log('on User created', resuser)
                        //             var status = resuser && resuser.status,
                        //                 data = resuser && resuser.data;
                        //             if (status == 200 || status == 201) {
                        //                 if (data.restoreId) {
                        //                     console.log('on restored id found', resuser)
                        //                     let formData={
                        //                         userId: a.user.userData.user.id,
                        //                         aliasId: data.alias,
                        //                         restoreId: data.restoreId
                        //                     }
                        //                     // console.log('setProperties', formData);
                        //                     service.post('employee/saveFreshchatId', formData, {
                        //                         'Authorization': self.userToken,
                        //                         'cs3-context-role': self.userRole,
                        //                         'cs3-context-clientId': self.userClientID,
                        //                     })
                        //                     .then((res) => {
                        //                         console.log('updated fresh chat Ids.')
                        //                     }).catch((err) => {
                        //                         console.log(err);
                        //                     })
                        //                 }
                        //             }
                        //         }));
                        //     }else {
                        //         console.log(data);
                        //     }
                        // });
                    // }
                    /* END CHAT SUPPORT */

                    window.fcWidget.init({
                        token: "5f5b4092-cff9-4586-9c85-5d4c79365f71",
                        host: "https://wchat.freshchat.com",
                        config: {
                        headerProperty: { 
                            hideChatButton: true 
                        } 
                        }
                    });
                    if (data.role.slug == "client-admin" || data.role.slug == "employee" || data.role.slug == "power-user" || data.role.slug == "auditor") {
                        if(data.user && data.user.employees && data.user.employees.length && data.user.employees[0].client_employee && data.user.employees[0].client_employee.clients){
                            this.$cookies.set("time_zone", data.user.employees[0].client_employee.clients.timezone, "23h");
                            this.$cookies.set("date_format", data.user.employees[0].date_format, "23h");
                            this.$cookies.set("time_format", data.user.employees[0].time_format, "23h");
                            this.$cookies.set("powerSteward", data.user.employees[0].client_employee.clients.power_steward, "23h");
                            var notifyType = (data.user.employees[0].email_notification == 1) ? 'email' : 'sms';

                            this.$store.dispatch('setNotificationType', notifyType);
                            this.$store.dispatch('setClientdata', data.user.employees[0].client_employee.clients);
                        }
                        if (data.role.slug == "client-admin" || data.role.slug == "power-user") {
                            this.$store.dispatch('setLastOpenJob', 0);
                            
                            if(data.role.slug == "power-user"){
                                this.$router.push({
                                    path: "/switchClient"
                                });
                            }
                            else{
                                this.$router.push({
                                    path: "/jobList"
                                });
                            }
                        } else { // role='employee'
                            if(document.getElementsByTagName('body')[0].clientWidth < 700)
                            { 
                                // mobile screen check
                                this.$cookies.set("csLogin", data.role.slug, "23h",'/mobile');
                                this.$cookies.set("date_format", data.user.employees[0].date_format, "23h", '/mobile');
                                this.$cookies.set("time_format", data.user.employees[0].time_format, "23h", '/mobile');
                                window.location.href = window.location.href.split('#')[0]+"mobile/";
                            } else{

                                // role='employee'
                                //for heard refresh.
                                //location.reload(true);


                                // this.$router.push({
                                //     path: "/switchClient"
                                // });
                                this.$router.push({
                                    path: "/myProfile"
                                });
                                // this.$router.push({
                                //     path: "/schedule/"+btoa(this.employeeId),
                                // });
                            }
                        }

                    } else if(data.role.slug == "employer-admin" || data.role.slug == "employer"){

                        // console.log("Hi I am Employer Admin.");
                        window.location.reload(true);
                        this.$router.push({
                            path: "/employerJobList"
                        });

                    } else if(data.role.slug == "super-admin") {
                        //location.reload(true);
                        this.$router.push({
                            path: "/clientList"
                        });
                    }                                
                }
                this.loading=false;
            }
        },
        mounted(){
            $('.force-login').parent('.wrapper').css('margin-left', '0');
        }
    }
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/forceLogin.vue